<div class="appContentsContainer">
  <div
    id="mantenimientoContainer"
    class="backgroundSand container fullWidthContainer listPage"
  >
    <div class="pageTitle">{{ "reforms.titleList" | translate }}</div>
    <div class="filterTableContainer">
      <app-table
        [tableList]="tableList"
        [elementList]="reformsList"
        [routing]="routing"
        [numPages]="numPages"
        [numElements]="numElements"
        [totalElements]="totalElements"
        [filterParams]="filtersTableJSON"
        [options]="options"
        (valueFilterTable)="filterTable($event)"
      ></app-table>
    </div>
  </div>
</div>
